import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 89 10",
  "content": "<symbol viewBox=\"0 0 89 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line\">\r\n<path d=\"M2.56511 7.73641C18.2901 4.68997 57.0205 -0.269654 86.1426 4.26336\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\" />\r\n<path d=\"M2.56511 7.73641C18.2901 4.68997 57.0205 -0.269654 86.1426 4.26336\" stroke=\"url(#icon-line_paint0_linear_245_2522)\" stroke-width=\"4\" stroke-linecap=\"round\" />\r\n<defs>\r\n<linearGradient id=\"icon-line_paint0_linear_245_2522\" x1=\"2.62338\" y1=\"4.54905\" x2=\"86.1094\" y2=\"6.07517\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"#FF9371\" />\r\n<stop offset=\"0.970006\" stop-color=\"#FFDE68\" />\r\n</linearGradient>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line.svg
// module id = 9xjd
// module chunks = 0